module.exports = __webpack_public_path__ + "static/img/5.3505fde.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/sp/5.png
// module id = 4+XX
// module chunks = 0